import { render, staticRenderFns } from "./te-popover.vue?vue&type=template&id=3b2075b0"
import script from "./te-popover.vue?vue&type=script&lang=js"
export * from "./te-popover.vue?vue&type=script&lang=js"
import style0 from "./te-popover.vue?vue&type=style&index=0&id=3b2075b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports